import * as React from 'react';
import { UserModel, UserDataModel } from 'franke-trough-dependencies';
import './UserListItem.scss';
import { GlobalPrivateState, formatDate } from 'src/api';
import { connect } from 'react-redux';
import cross from '../../../../assets/images/icons/cross-rounded.svg';
import calendarRed from '../../../../assets/images/icons/calendar-red.svg';
import calendarGreen from '../../../../assets/images/icons/calendar-green.svg';
import { userIsInternal, userIsSalesRep } from '../utils';
import UserListScheduleModal from './UserListScheduleModal';
import { requestAPIActions } from 'loopback-react-request';
 
export interface UserListItemProps {
  manager: UserModel;
  user: UserModel;
  drilledRemoveManagee: (user: UserModel) => void;
  drilledUpdateManagee: (managee: UserModel) => void;
  language: GlobalPrivateState['localize']['language'];
  dispatch: any;
}
export interface UserListItemRemoveState {
  isScheduling: boolean;
}

export class UserListItemRemovePartial extends React.Component<UserListItemProps, UserListItemRemoveState> {
  constructor(props: UserListItemProps) {
    super(props);

    this.state = {
      isScheduling: false
    };
  }

  public render() {
    const user = this.props.user;
    const userData = (user.userData as UserDataModel);
    const firstName = userData && userData.firstName;
    const lastName = userData && userData.lastName;
    const country = userData && userData.country.split('-')[1];
    const registration = userData && new Date(userData.created_at).toLocaleDateString(this.props.language.selected, {timeZone: 'UTC'});
    const labour = userData && userData.labour || '';
    const role = userIsInternal(user) ? 'internal' : userIsSalesRep(user) ? 'salesrep' : 'external';

    const manageeMapping = user.manageeMapping && user.manageeMapping.find((m: any) => m.managerId === this.props.manager.id);
    const mappingFrom = manageeMapping && manageeMapping.dateFrom && manageeMapping.dateFrom.split('T')[0];
    const mappingUntil = manageeMapping && manageeMapping.dateUntil && manageeMapping.dateUntil.split('T')[0];
    const calenderIcon = manageeMapping && manageeMapping.dateFrom ? calendarGreen : calendarRed;
    const calendarLabel = mappingFrom ? `From ${mappingFrom && formatDate(mappingFrom) || 'forever'} to ${mappingUntil && formatDate(mappingUntil) || 'forever'}` : 'Set a temporary substitute';

    return (
      <li key={user.id} className={'user-list-item user-list-item--add user-list-item--clickable'}>
        <div className="user-list-item__header">
          <span className="user-list__first" title={firstName}>{firstName}</span>
          <span className="user-list__last" title={lastName}>{lastName}</span>
          <span className="user-list__email" title={user.email}>{user.email}</span>
          <span className="user-list__country">{country}</span>
          <span className="user-list__registration">{registration}</span>
          <span className="user-list__labour">{labour}</span>
          <span className="user-list__role">{role}</span>
          <span className="user-list__action">
            {(userIsInternal(user) || userIsSalesRep(user)) && (
              <img 
                className="img-fluid" 
                src={calenderIcon}
                alt="calendar"
                title={calendarLabel}
                onClick={(e) => this.handleOpenSchedule(user)}
                style={{height: 20}}
              />
            )}
          </span>
          <span className="user-list__action">
            <img 
              className="img-fluid" 
              src={cross}
              alt="remove"
              onClick={(e) => this.props.drilledRemoveManagee(user)}
            />
          </span>
        </div>
        {this.state.isScheduling && (
          <UserListScheduleModal
            user={user} 
            drilledClose={this.onDrilledCloseSchedule}
            drilledConfirm={this.onDrilledConfirmSchedule}
            schedule={manageeMapping}
          />
        )}
      </li>
    );
  }

  handleOpenSchedule = (user: UserModel) => {
    this.setState({
      ...this.state,
      isScheduling: true
    });
  }

  onDrilledCloseSchedule = () => {
    this.setState({
      ...this.state,
      isScheduling: false
    });
  }

  onDrilledConfirmSchedule = (user: UserModel, dateFrom: string | null, dateUntil: string | null) => {

    if (dateUntil === '') { dateUntil = null }

    const data = {
      managerId: this.props.manager.id,
      manageeId: user.id
    }

    const mapping = {
      ...data,
      dateFrom,
      dateUntil,
    }
    
    this.props.dispatch(requestAPIActions.load(
      'manageMapping', {
        url: `/ManageMappings/upsertWithWhere?where=${JSON.stringify(data)}`,
        options: {
          method: 'POST',
          data: mapping
        }
      },
      false
    ));

    // After api request is completed, need to go and update the state as well...
    user = JSON.parse(JSON.stringify(user)); // If I don't do this, somehow the change is remembered, aghhhhhhhhhh
    if (!user.manageeMapping) {
      user.manageeMapping = [];
    }

    let changedMappingIndex = user.manageeMapping.findIndex(m => m.managerId === this.props.manager.id && m.manageeId === user.id);
    if (changedMappingIndex === -1) { changedMappingIndex = 0; }

    user.manageeMapping[changedMappingIndex] = mapping;

    this.props.drilledUpdateManagee(user);
  }
}

export const UserListItemRemove = connect((state: GlobalPrivateState) => ({
  language: state.localize.language,
  usersAdminList: state.users,
  queryState: state.queryState
}))(UserListItemRemovePartial);

export default UserListItemRemove;
